import React, { useEffect } from 'react';
import { loadModules } from 'esri-loader';

const ArcGISHeatMap = () => {
  useEffect(() => {
    loadModules([
      'esri/WebMap',
      'esri/views/MapView',
      'esri/widgets/LayerList',
      'esri/geometry/Extent', // Import Extent module
    ]).then(([
               WebMap,
               MapView,
               LayerList,
               Extent, // Get Extent module
             ]) => {
      const map = new WebMap({
        portalItem: {
          id: 'd5dda743788a4b0688fe48f43ae7beb9',
        },
      });

      // Define an extent for the entire USA
      const usaExtent = new Extent({
        xmin: -130.148909,
        ymin: 30.7763,
        xmax: -50.934570,
        ymax: 40.538800,
        spatialReference: { wkid: 4326 } // Geographic coordinate system (WGS 1984)
      });

      const view = new MapView({
        container: 'viewDiv',
        map: map,
        extent: usaExtent, // Set the initial extent to cover the USA
      });

      const layerList = new LayerList({
        view: view,
        listItemCreatedFunction: (event: any) => {
          const item = event.item;
          if (item.layer.type !== 'group') {
            item.panel = {
              content: 'legend',
              open: true,
            };
            item.layer.title = 'Social Demography'
          }
        },
      });

      view.ui.add(layerList, 'top-right');
    });
  }, []);

  return <div id="viewDiv" style={{ height: '100%' }}></div>;
};

export default ArcGISHeatMap;
